import { LogLevel } from './enums/log-level.enum';

export class LogEntry {
    timestamp: Date;
    level: string;
    message: string;

    constructor(level: LogLevel, message: string, timestamp: Date) {
        this.timestamp = timestamp;
        this.level = LogLevel[level];
        this.message = message;
    }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/log-entry.ts